import { JUNOContent } from '../../../../../types/global';
import ReactComponent from '../../../../ReactComponent';
export default class NotificationsContentEditorPanel extends BaseEditorPanel {
  changed: boolean = false;
  mConstructorParams: any;
  mContent: JUNOContent;
  mDiv: JQuery<HTMLElement>;
  mVars = {};

  constructor() {
    super();
  }

  initialize(aConstructorParams): void {
    this.mConstructorParams = aConstructorParams;
    this.mContent = aConstructorParams.content;
    this.mDiv = this._generateHtml();
    this._injectReactComponent();
    super.initialize(aConstructorParams);
    this.mVars = this.mContent.RawData;
    $('.save_button_container').hide();
  }
  private _injectReactComponent() {
    const adminNotificationsModule = new ReactComponent();
    adminNotificationsModule.inject('AdminNotficationsModule', this.mDiv, {
      /*ADD PARAMS HERE*/
    });
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(HGEN.tree({ style: 'notifications_content_editor_panel' }));
  }

  hasChanged(): boolean {
    return this.changed;
  }

  collectVars() {
    let aVars = super.collectVars();
    return aVars;
  }

  getDiv(): JQuery<HTMLElement> {
    return this.mDiv;
  }
}
